// Admin-published, product-wide guidance file (backend Document with scope
// ProductResource). Shared by the Document Hub (admin), the on-site checklist
// step tiles, and the read-only Guidance section of the Documents tab.
export interface ProductResource {
  id: number;
  targetProduct: number;
  targetStep: number | null; // canonical checklist step (meta.number); null = general
  title: string | null;
  language: string | null;
  originalName: string;
  contentType: string;
  sizeBytes: number;
  createdAt: string;
}

export function isVideoResource(r: ProductResource): boolean {
  return r.contentType.startsWith('video/');
}
